export default "__VITE_ASSET___CTCCB7u__"